import { css } from 'lit';
export default css `
  :host {
    box-sizing: border-box;
    display: block;
    width: 100%;
  }

  .message {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    padding: 12px 14px;
    border-width: 1px;
    border-style: solid;
    border-radius: var(--amityeko-radius-small);
  }

  ::slotted([slot='custom-icon']),
  .message__icon {
    display: flex;
    justify-content: center;
    width: 24px;
    margin-right: 14px;
  }

  /* Variant: success */
  .message[variant='success'] {
    background-color: var(--amityeko-color-success-1);
    border-color: var(--amityeko-color-success-2);
  }

  .message[variant='success'] .message__text::part(base) {
    color: var(--amityeko-color-success-6);
  }

  .message[variant='success'] .message__icon,
  .message[variant='success'] ::slotted([slot='custom-icon']) {
    --amityeko-icon-color: var(--amityeko-color-success-6);
  }

  /* Variant: error */
  .message[variant='error'] {
    background-color: var(--amityeko-color-destructive-1);
    border-color: var(--amityeko-color-destructive-2);
  }

  .message[variant='error'] .message__text::part(base) {
    color: var(--amityeko-color-destructive-6);
  }

  .message[variant='error'] .message__icon,
  .message[variant='error'] ::slotted([slot='custom-icon']) {
    --amityeko-icon-color: var(--amityeko-color-destructive-6);
  }

  /* Variant: caution */
  .message[variant='caution'] {
    background-color: var(--amityeko-color-caution-1);
    border-color: var(--amityeko-color-caution-2);
  }

  .message[variant='caution'] .message__text::part(base) {
    color: var(--amityeko-color-caution-6);
  }

  .message[variant='caution'] .message__icon,
  .message[variant='caution'] ::slotted([slot='custom-icon']) {
    --amityeko-icon-color: var(--amityeko-color-caution-6);
  }

  /* Variant: info */
  .message[variant='info'] {
    background-color: var(--amityeko-color-info-1);
    border-color: var(--amityeko-color-info-2);
  }

  .message[variant='info'] .message__text::part(base) {
    color: var(--amityeko-color-info-6);
  }

  .message[variant='info'] .message__icon,
  .message[variant='info'] ::slotted([slot='custom-icon']) {
    --amityeko-icon-color: var(--amityeko-color-info-6);
  }

  /* Animations */
  :host {
    max-height: 100px;
    opacity: 1;
    transition: margin 2s 1s, max-height 2s 1s, opacity 2s;
  }

  :host(.animate-out) {
    max-height: 0;
    opacity: 0;
  }
`;
//# sourceMappingURL=styles.js.map